import React from 'react';

import { Tooltip } from 'antd';

interface IIconPaymentMethodProps {
  cardBrand: string;
}

const IconPaymentMethod = ({ cardBrand }: IIconPaymentMethodProps) => {
  return (
    <>
      <Tooltip placement='top' title={cardBrand ? cardBrand : 'Boleto'}>
        <img
          className='ml-1 inline w-4'
          alt={cardBrand ?? 'Boleto'}
          src={cardBrand ? `/img/brands/payment/${cardBrand}.svg` : '/img/brands/payment/Boleto.svg'}
        />
      </Tooltip>
    </>
  );
};
export default IconPaymentMethod;
